var lottieConfig = {
  theme: 'light',
  height: 100,
  width: 100,
  hideOnAnimationFinish: false,
  loop: false
};
export default {
  light: lottieConfig,
  dark: lottieConfig,
  white: lottieConfig
};